<template>
  <div class="card card-shadow">
    <div class="card-header">
      <h1 class="h4">{{ translate('previews.coupon.title') }}</h1>
    </div>
    <div class="card-body p-4">
      <div class="row">
        <div class="col-lg-12 text-center">
          <span style="font-size: 50px;"></span>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <ul style="list-style-type: none; padding-inline-start: 0" class="mb-0">
            <li>{{ translate('previews.coupon.info.id') }}: <span class="font-weight-bold">{{ coupon.id }}</span></li>
            <li>{{ translate('previews.coupon.info.name') }}: <span class="font-weight-bold">{{ coupon.name }}</span>
            </li>
            <li>{{ translate('previews.coupon.info.code') }}: <span class="font-weight-bold">{{ coupon.code }}</span>
            </li>
            <li>{{ translate('previews.coupon.info.discount') }}: <span class="font-weight-bold">{{ coupon | discount }}</span></li>
            <li>{{ translate('previews.coupon.info.limit_count') }}: <span class="font-weight-bold">{{ coupon.limit_count }}</span></li>
            <li>{{ translate('previews.coupon.info.used_times') }}: <span class="font-weight-bold">{{ coupon.payments_count }}</span></li>
            <li>{{ translate('previews.coupon.info.ends_at') }}: <span class="font-weight-bold">{{ coupon.ends_at | formatDate }}</span></li>
            <li>{{ translate('previews.coupon.info.active') }}:
              <span v-if="coupon.active" class="font-weight-bold">
                {{ translate('tables.coupons.active.yes') }}
              </span>
              <span v-else class="font-weight-bold">
                {{ translate('tables.coupons.active.no') }}
              </span>
            </li>
            <li>{{ translate('previews.coupon.info.created_at') }}: <span class="font-weight-bold">{{ coupon.created_at | formatDate }}</span></li>
          </ul>
        </div>
      </div>

      <hr>

      <div class="row">
        <div class="col-md-12 mt-2">
          <button
            class="btn btn-block btn-primary text-white"
            @click="showEditCouponModal">
            {{ translate('previews.buttons.edit') }}
          </button>
        </div>

        <div class="col-md-12 mt-2">
          <button
            v-if="coupon.can.delete"
            class="btn btn-block btn-danger text-white"
            @click="showDeleteCouponModal">
            {{ translate('previews.buttons.delete') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';

export default {
  props: ['coupon'],

  data () {
    return {};
  },

  filters: {
    formatDate: function (value) {
      if (value) {
        return moment(String(value)).format('YYYY-MM-DD');
      }
    },

    discount: function (coupon) {
      if (coupon.type === 'percentage') {
        return coupon.percentage + ' %';
      }
      if (coupon.type === 'amount') {
        return coupon.amount + ' €';
      }
    },
  },

  methods: {
    showEditCouponModal () {
      this.$parent.$emit('showEditCouponModal');
    },

    showDeleteCouponModal () {
      this.$parent.$emit('showDeleteCouponModal');
    }
  }
};
</script>
